import React from 'react';

export const name = 'flag-MT';

export const FlagMT = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_345)">
      <mask
        id="mask0_2_345"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_345)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#EEEEEE"
        />
        <path
          d="M12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.81742 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24"
          fill="#D80027"
        />
        <path
          d="M8.34375 4.69692V3.13129H6.78281V4.69692H5.21719V6.26255H6.78281V7.82817H8.34844V6.26255H9.91406V4.69692H8.34375Z"
          fill="#ACABB1"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_345">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
